<div class="messages-container" #messagesContainer>
  <div *ngIf="loading" class="loading-spinner">
    <mat-spinner diameter="24"></mat-spinner>
  </div>
  <div *ngIf="!conversationId" class="no-conversation">
    Selecciona una conversación o crea una nueva
  </div>
  <div
    *ngFor="let msg of messages"
    class="message"
    [class.user-msg]="msg.role === 'user'"
    [class.assistant-msg]="msg.role === 'assistant'"
  >
    <div class="message-bubble">
      <div class="message-content" [innerHTML]="renderContent(msg.content)"></div>
      <div *ngIf="msg.sources_json && msg.sources_json.length > 0" class="message-sources">
        <small>Fuentes: {{ msg.sources_json.join(', ') }}</small>
      </div>
    </div>
  </div>
</div>
